import { render, staticRenderFns } from "./PacmanLoaderNew.htm?vue&type=template&id=fa45c4c8&scoped=true&"
import script from "./PacmanLoaderNew.js?vue&type=script&lang=js&"
export * from "./PacmanLoaderNew.js?vue&type=script&lang=js&"
import style0 from "./PacmanLoaderNew.scss?vue&type=style&index=0&id=fa45c4c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa45c4c8",
  null
  
)

export default component.exports